import React, { type CSSProperties } from 'react';

import classnames from 'classnames';

import { HighLight, Tag, Text, Tooltip, type TooltipProps } from 'styled-system';

import styles from './Group.module.scss';

type GroupProps = {
    color: string;
    className?: string;
    disabled?: boolean;
    highlight?: string;
    includeCounts?: boolean;
    initials: string;
    members?: string[];
    name: string;
    style?: CSSProperties;
    tooltip?: Pick<TooltipProps, 'title' | 'align' | 'placement'>;
    withBackground?: boolean;
};

export const Group = ({
    className,
    color,
    disabled,
    highlight,
    includeCounts,
    initials,
    members = [],
    name,
    style,
    tooltip,
    withBackground
}: GroupProps) => {
    return (
        <div
            className={classnames(styles.group, className, {
                [styles.withBackground]: withBackground
            })}
        >
            <Tooltip
                align={tooltip?.align}
                disabled={disabled}
                placement={tooltip?.placement}
                title={tooltip?.title}
            >
                <span className={styles.groupRow}>
                    <Tag className={styles.tag} text={initials} color={color} />
                    <Text className={classnames(styles.text, className)} style={style}>
                        <HighLight className={styles.highlight} highlight={highlight} text={name} />
                        {members?.length || includeCounts ? ` (${members.length})` : ''}
                    </Text>
                </span>
            </Tooltip>
        </div>
    );
};
